import React, { useEffect, useState } from 'react';
import Header from '../components/header';
import Footers from '../components/footers';
import { Button, Label, Radio } from 'flowbite-react';
import { AiOutlineLoading } from 'react-icons/ai';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { serverURL } from '../constants';
import { useLocation } from 'react-router-dom';
import TopicBlocks from '../components/TopicBlocks';
import { useTranslation } from 'react-i18next';
import '../i18n'; // Import the i18n configuration

const Create = () => {
    const { t, i18n } = useTranslation();

    const maxSubtopics = 5;
    const [formValues, setFormValues] = useState([{ sub: "" }]);
    const [processing, setProcessing] = useState(false);
    const [selectedValue, setSelectedValue] = useState('5');
    const [selectedType, setSelectedType] = useState('Text & Image Course');
    const [paidMember, setPaidMember] = useState(false);
    const [lableText, setLableText] = useState(t('course_creation.free_member_limit'));

    const navigate = useNavigate();
    const location = useLocation();
    const eventTitle = location.state?.eventTitle || '';

    useEffect(() => {
        setPaidMember(true);
        if (localStorage.getItem('type') !== 'free') {
            setLableText(t('course_creation.subtopics_count'));
        }
    }, [t]);

    let handleChange = (i, e) => {
        let newFormValues = [...formValues];
        newFormValues[i] = e.target.value;
        setFormValues(newFormValues);
    }

    let addFormFields = () => {
        if (formValues.length < maxSubtopics) {
            setFormValues([...formValues, { sub: "" }]);
        } else {
            showToast(t('messages.max_subtopics_reached'));
        }
    }

    let removeFormFields = () => {
        let newFormValues = [...formValues];
        newFormValues.pop();
        setFormValues(newFormValues);
    }

    const showPaidToast = async () => {
        if (!paidMember) {
            toast(t('messages.paid_members_only'), {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        }
    }

    const showToast = async (msg) => {
        toast(msg, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
        });
    }

    const getUsersCoursesNumber = () => {
        const userId = localStorage.getItem('uid');
        const postURL = serverURL + `/api/courses/count?userId=${userId}`;
        try {
            const response = axios.get(postURL);
            return response.data.count;
        } catch (error) {
            // Handle error
        }
    };

    async function checkCourseCount() {
        if (localStorage.getItem('type') === 'free') {
            const userId = localStorage.getItem('uid');
            const postURL = serverURL + `/api/courses/count?userId=${userId}`;
            try {
                const response = await axios.get(postURL);
                return response.data.count;
            } catch (error) {
                setProcessing(false);
                showToast(t('messages.failed_course_count'));
                return;
            }
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const subtopics = [];
        setProcessing(true);
        formValues.forEach(subtopic => {
            subtopics.push(subtopic);
        });
        const mainTopic = document.getElementById('topic1').value;

        if (!mainTopic.trim()) {
            setProcessing(false);
            showToast(t('messages.fill_required_fields'));
            return;
        }

        if (subtopics.length === 0) {
            setProcessing(false);
            showToast(t('messages.fill_required_fields'));
            return;
        }

        checkCourseCount().then((count) => {
            if (localStorage.getItem('type') === 'free' && count >= 5) {
                setProcessing(false);
                showToast(t('messages.free_course_limit'));
                return;
            }

            const prompt = `Strictly in chinese, Generate a list of Strict ${selectedValue} topics and any number sub topic for each topic for main title ${mainTopic.toLowerCase()}, everything in single line. Those ${selectedValue} topics should Strictly include these topics :- ${subtopics.join(', ').toLowerCase()}. Strictly Keep theory, youtube, image field empty and do not act as an chatbot. Generate in the form of JSON in this format {
                "${mainTopic.toLowerCase()}": [
           {
           "title": "Topic Title",
           "subtopics": [
            {
            "title": "Sub Topic Title",
            "theory": "",
            "youtube": "",
            "image": "",
            "done": false
            },
            {
            "title": "Sub Topic Title",
            "theory": "",
            "youtube": "",
            "image": "",
            "done": false
            }
           ]
           },
           {
           "title": "Topic Title",
           "subtopics": [
            {
            "title": "Sub Topic Title",
            "theory": "",
            "youtube": "",
            "image": "",
            "done": false
            },
            {
            "title": "Sub Topic Title",
            "theory": "",
            "youtube": "",
            "image": "",
            "done": false
            }
           ]
           }
          ]
          }`;
            sendPrompt(prompt, mainTopic, selectedType)
        }).catch((error) => {
            setProcessing(false);
            showToast(t('messages.failed_course_count'));
            return;
        });
    };

    async function sendPrompt(prompt, mainTopic, selectedType) {
        const dataToSend = {
            prompt: prompt,
        };
        try {
            const postURL = serverURL + '/api/prompt';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.generatedText;
            const cleanedJsonString = generatedText.replace(/```json/g, '').replace(/```/g, '');
            try {
                const parsedJson = JSON.parse(cleanedJsonString);
                setProcessing(false);
                navigate('/topics', { state: { jsonData: parsedJson, mainTopic: mainTopic.toLowerCase(), type: selectedType.toLowerCase() } });
            } catch (error) {
                sendPrompt(prompt, mainTopic, selectedType);
            }
        } catch (error) {
            sendPrompt(prompt, mainTopic, selectedType);
        }
    }

    const handleRadioChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const handleRadioChangeType = (event) => {
        setSelectedType(event.target.value);
    };

    return (
        <div className='h-screen flex flex-col'>
            <Header isHome={true} className="sticky top-0 z-50" />

            <div className='dark:bg-black flex-1'>
                <div className='flex-1 flex items-center justify-center py-10'>
                    <form onSubmit={handleSubmit} className="max-w-sm m-auto py-4 no-scrollbar">
                        <p className='text-center font-black text-4xl text-black dark:text-white'>
                            {t('course_creation.generate_course')}
                        </p>
                        <p className='text-center font-normal text-black py-4 dark:text-white'>
                            {t('course_creation.introduction')}
                        </p>
                        <div className='py-6'>
                            <div className='mb-6'>
                                <div className="mb-2 block">
                                    <Label
                                        className="font-bold text-black dark:text-white"
                                        htmlFor="topic1"
                                        value={t('course_creation.topic_label')}
                                    />
                                </div>
                                <input
                                    className='focus:ring-black focus:border-black border border-black font-normal bg-white rounded-none block w-full dark:bg-black dark:border-white dark:text-white'
                                    id="topic1"
                                    type="text"
                                    defaultValue={eventTitle}
                                />
                                <TopicBlocks
                                    onTopicSelect={(topic) => {
                                        const topicInput = document.getElementById('topic1');
                                        if (topicInput) {
                                            topicInput.value = topic;
                                        }
                                    }}
                                />
                            </div>
                            <div className='mb-6'>
                                <div className="mb-2 block">
                                    <Label
                                        className="font-bold text-black dark:text-white"
                                        htmlFor="subtopic"
                                        value={t('course_creation.subtopic_label')}
                                    />
                                </div>
                                {formValues.map((element, index) => (
                                    <div key={index}>
                                        <input
                                            onChange={e => handleChange(index, e)}
                                            className='focus:ring-black focus:border-black border border-black font-normal bg-white rounded-none block w-full dark:bg-black dark:border-white dark:text-white mb-6'
                                            name={"sub-" + index}
                                            id="subtopic"
                                            type="text"
                                        />
                                    </div>
                                ))}
                            </div>
                            <p>{t('course_creation.subtopic_help')}</p>
                            <Button
                                type="button"
                                onClick={() => addFormFields()}
                                className='mb-6 items-center justify-center text-center dark:bg-white dark:text-black bg-black text-white font-bold rounded-none w-full enabled:hover:bg-black enabled:focus:bg-black enabled:focus:ring-transparent dark:enabled:hover:bg-white dark:enabled:focus:bg-white dark:enabled:focus:ring-transparent'
                            >
                                {t('course_creation.add_subtopic')}
                            </Button>

                            {formValues.length > 1 && (
                                <Button
                                    type="button"
                                    onClick={() => removeFormFields()}
                                    className='mb-6 items-center justify-center text-center border-black dark:border-white dark:bg-black dark:text-white bg-white text-black font-bold rounded-none w-full enabled:hover:bg-white enabled:focus:bg-white enabled:focus:ring-transparent dark:enabled:hover:bg-black dark:enabled:focus:bg-black dark:enabled:focus:ring-transparent'
                                >
                                    {t('course_creation.remove_subtopic')}
                                </Button>
                            )}

                            <Label
                                className="font-bold text-black dark:text-white"
                                htmlFor="nosubtopic"
                                value={lableText}
                            />
                            <fieldset className="flex max-w-md flex-col gap-4 mt-2">
                                <div className="flex items-center gap-2 px-2 h-11 focus:ring-black focus:border-black border border-black font-normal bg-white rounded-none w-full dark:bg-black dark:border-white dark:text-white">
                                    <Radio
                                        onChange={handleRadioChange}
                                        className='text-black border-black dark:text-white dark:border-white dark:focus:text-black focus:ring-black dark:focus:ring-white dark:focus:bg-black '
                                        id="5"
                                        name="value"
                                        value="5"
                                        defaultChecked
                                    />
                                    <Label
                                        className='text-black dark:text-white font-bold'
                                        htmlFor="4"
                                    >
                                        {t('course_creation.subtopics_count_five')}
                                    </Label>
                                </div>
                                <div
                                    onClick={() => showPaidToast()}
                                    className="flex items-center gap-2 px-2 h-11 focus:ring-black focus:border-black border border-black font-normal bg-white rounded-none w-full dark:bg-black dark:border-white dark:text-white mb-6"
                                >
                                    <Radio
                                        onChange={handleRadioChange}
                                        disabled={!paidMember}
                                        className='text-black border-black dark:text-white dark:border-white dark:focus:text-black focus:ring-black dark:focus:ring-white dark:focus:bg-black '
                                        id="10"
                                        name="value"
                                        value="10"
                                    />
                                    <Label
                                        className='text-black dark:text-white font-bold'
                                        htmlFor="7"
                                    >
                                        {t('course_creation.subtopics_count_ten')}
                                    </Label>
                                </div>
                            </fieldset>

                            <Label
                                className="font-bold text-black dark:text-white"
                                htmlFor="nosubtopic"
                                value={t('course_creation.course_type')}
                            />
                            <fieldset className="flex max-w-md flex-col gap-4 mt-2">
                                <div
                                    onClick={() => showPaidToast()}
                                    className="flex items-center gap-2 px-2 h-11 focus:ring-black focus:border-black border border-black font-normal bg-white rounded-none w-full dark:bg-black dark:border-white dark:text-white mb-6"
                                >
                                    <Radio
                                        onChange={handleRadioChangeType}
                                        disabled={!paidMember}
                                        className='text-black border-black dark:text-white dark:border-white dark:focus:text-black focus:ring-black dark:focus:ring-white dark:focus:bg-black '
                                        id="videocourse"
                                        name="value1"
                                        value="Video & Text Course"
                                    />
                                    <Label
                                        className='text-black dark:text-white font-bold'
                                        htmlFor="videocourse"
                                    >
                                        {t('course_creation.video_text_course')}
                                    </Label>
                                </div>
                            </fieldset>

                            <Button
                                isProcessing={processing}
                                processingSpinner={<AiOutlineLoading className="h-6 w-6 animate-spin" />}
                                className='items-center justify-center text-center dark:bg-white dark:text-black bg-black text-white font-bold rounded-none w-full enabled:hover:bg-black enabled:focus:bg-black enabled:focus:ring-transparent dark:enabled:hover:bg-white dark:enabled:focus:bg-white dark:enabled:focus:ring-transparent'
                                type="submit"
                            >
                                {t('course_creation.submit')}
                            </Button>
                        </div>
                    </form>
                </div>
            </div>

            <Footers className="sticky bottom-0 z-50" />
        </div>
    );
};

export default Create;